

















































import Vue from 'vue'
import UiIcon from '../UiIcon'
import { Data } from './UiPagination.types'

export default Vue.extend({
  name: 'UiPagination',
  components: {
    UiIcon
  },
  props: {
    url: {
      type: String,
      default: '/'
    },
    path: {
      type: String,
      default: ''
    },
    pageCount: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    },
    link: {
      type: Boolean,
      default: true
    },
    showPages: {
      type: Number,
      default: 5
    },
    showPagesCount: {
      type: Number,
      default: 3
    },
    break: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    locale () {
      return (this as any).$typo3?.i18n?.locale !== (this as any).$typo3?.i18n?.defaultLocale
        ? `/${(this as any).$typo3.i18n.locale}`
        : ''
    },
    next () {
      return this.current < this.pageCount ? (this as any).getUrl(this.current + 1) : false
    },
    prev () {
      return this.current > 1 ? (this as any).getUrl(this.current - 1) : false
    },
    pages () {
      const range = []
      const pages = []
      let l
      // 1 2 3 4 5
      if (this.pageCount <= this.showPages) {
        for (let i = 1; i <= this.pageCount; i++) {
          pages.push((this as any).getData(i))
        }
      } else {
        // 1 [2] 3 ... 10
        // 1 ... 5 [6] 7 ... 10
        // 1 ... 8 [9] 10
        range.push(1)
        for (let i = this.current - 1; i <= this.current + 1; i++) {
          if (i < this.pageCount && i > 1) {
            range.push(i)
          }
        }
        range.push(this.pageCount)

        for (const i of range) {
          if (l) {
            if (i - l === 2) {
              pages.push((this as any).getData(l + 1))
            } else if (i - l !== 1) {
              pages.push((this as any).createBreak())
            }
          }
          pages.push((this as any).getData(i))
          l = i
        }
      }
      return pages
    }
  },
  methods: {
    getUrl (number: number): string {
      return `${(this as any).locale}${number === 1 ? this.url : `${this.url}${this.path}${number}`}`
    },
    getData (index: number): Data {
      return {
        current: index === this.current,
        url: (this as any).getUrl(index),
        index: index
      }
    },
    createBreak (): Data {
      return {
        current: false,
        url: false,
        break: true
      }
    }
  }
})
